import { Vehicle } from '../core/Vehicle';
import * as THREE from 'three';

export class Car extends Vehicle {
  constructor() {
    super();
    this.maxSpeed = 12;
    this.acceleration = 0.15;
    this.createModel();
  }

  public createModel(): void {
    // Simple car model
    const body = new THREE.Mesh(
      new THREE.BoxGeometry(2, 1, 4),
      new THREE.MeshPhongMaterial({ color: 0xff0000 }) // Fixed hex color format
    );
    
    const cabin = new THREE.Mesh(
      new THREE.BoxGeometry(1.5, 1, 2),
      new THREE.MeshPhongMaterial({ color: 0x333333 })
    );
    cabin.position.y = 0.5;
    cabin.position.z = -0.5;

    this.mesh.add(body);
    this.mesh.add(cabin);
  }
}